import { AfterViewInit, Directive, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, ColGroupDef, GetLocaleTextParams } from 'ag-grid-community';

@Directive({
  selector: 'ag-grid-angular',
  standalone: false,
})
export class GridTranslateDirective implements AfterViewInit, OnInit {
  private agGrid = inject(AgGridAngular);
  private translate = inject(TranslateService);

  ngOnInit(): void {
    this.agGrid.getLocaleText = (params: GetLocaleTextParams): string => {
      const gridKey = 'Grid.' + params.key;
      return this.translate.instant(gridKey);
    };
  }

  ngAfterViewInit(): void {
    const colDefs = this.agGrid.api.getColumnDefs();
    if (colDefs) {
      this.translateColDefs(colDefs);
      this.agGrid.api.setGridOption('columnDefs', colDefs);
    }

    const autoGroupColumnDef = this.agGrid.gridOptions?.autoGroupColumnDef;
    if (autoGroupColumnDef) {
      if (autoGroupColumnDef.headerName) {
        autoGroupColumnDef.headerName = this.translate.instant(
          autoGroupColumnDef.headerName
        );
        this.agGrid.api.setGridOption('autoGroupColumnDef', autoGroupColumnDef);
      }
    }
  }
  translateColDefs(
    colDefs: (ColDef | ColGroupDef)[]
  ): (ColDef | ColGroupDef)[] {
    colDefs.forEach((colDef: ColDef | ColGroupDef) => {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if ((colDef as ColGroupDef).children) {
        // Translate if colDef has children, see: https://www.ag-grid.com/angular-data-grid/column-groups/
        this.translateColDefs((colDef as ColGroupDef).children);
      }

      if (colDef.headerName) {
        colDef.headerName = this.translate.instant(colDef.headerName);
      }

      if (colDef.headerTooltip) {
        colDef.headerTooltip = this.translate.instant(colDef.headerTooltip);
      }
    });
    return colDefs;
  }
}
